import type { FC } from 'react';

import classNames from 'classnames';

import RadioButton from '../../../radiobuttons/radiobuttons';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

import styles from './radio_buttons.module.css';

const componentProps = [
  'options',
  'name',
  'value',
  'onChange',
  'column',
  'disabled',
  'className',
  'radioButtonClassName',
  'column',
] as const;

const Field = formField(RadioButton, {
  defaultValue: '',
  transformProps: (props) => pickProps(props, componentProps),
});

export type RadioButtonsWrapperProps = FieldWrapperProps<typeof Field>;

const RadioButtonsWrapper: FC<RadioButtonsWrapperProps> = (props) => (
  <FormContextConsumer>
    {(context) => (
      <Field
        {...props}
        {...context}
        className={classNames(styles.root, props.className, {
          [styles.column]: props.column,
        })}
        radioButtonClassName={styles.radio_button}
      />
    )}
  </FormContextConsumer>
);

export default RadioButtonsWrapper;
